import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { ClientsApi } from 'entities/Clients/api/clients'
import {
  type IResponseHubSpotTeams,
  type IResponseClient,
  type IResponseGetClients,
} from 'entities/Clients/api/types'
import { RowClient } from 'entities/Clients/model/RowClient'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationKey } from 'entities/Integrations'
import { ClientsTabStore } from 'pages/clients/store/clientsTabStore'

export class ActiveClientsTabStore {
  private readonly _base: ClientsTabStore<IResponseClient, IResponseGetClients, RowClient>
  private _integrationsTeamsList: IResponseHubSpotTeams[] = []

  constructor(readonly entities: IEntitiesStore) {
    this._base = new ClientsTabStore<IResponseClient, IResponseGetClients, RowClient>({
      table: {
        key: 'active-clients-table',
        element: 'clients',
        useColumnsCache: true,
        sortBy: 'created_at',
      },
      request: (params) => ClientsApi.getClients(params),
      makeRow: (item) => new RowClient(item),
    })

    makeAutoObservable(this)
  }

  get tableStore() {
    return this._base.tableStore
  }

  get scrollToTopTrigger() {
    return this._base.scrollToTopTrigger
  }

  get itemsRows() {
    return this._base.itemsRows
  }

  get isGroupsFlowEnabled() {
    return this.entities.featureFlagsStore.groups_flow
  }

  init = () => {
    this._base.init()
    this.loadIntegrationsTeamsList()
  }

  loadData = () => this._base.loadData()

  loadIntegrationsTeamsList = async () => {
    try {
      const { data } = await ClientsApi.getHubSpotTeams()
      this._integrationsTeamsList = data
    } catch (error) {
      logger.error(error)
    }
  }

  get integrationsTeamsList() {
    return this._integrationsTeamsList
  }

  get isHubSpotConnected() {
    return (
      this.entities.integrationsStore.getIntegration(IntegrationKey.hubspot)?.isConnected ?? false
    )
  }

  dispose = () => {
    this._base.dispose()
  }
}
